const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSMedalBadgeCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "iconS-medal-badge-check",
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.63,14.633l0,0.003c0,4.528 -2.06,8.576 -5.295,11.256l-0.023,0.018c-0,0 -0.048,0.062 -0.048,0.099l0,12.775c0,0.672 -0.544,1.216 -1.216,1.216c-0.192,-0 -0.375,-0.045 -0.536,-0.125c-0.003,-0.001 -0.005,-0.002 -0.007,-0.003l-7.452,-3.726c-0.035,-0.017 -0.077,-0.017 -0.112,0l-7.45,3.726c-0.158,0.081 -0.345,0.128 -0.543,0.128c-0.672,-0 -1.216,-0.544 -1.216,-1.216l-0,-12.774c-0,-0.037 -0.017,-0.072 -0.046,-0.096c-3.257,-2.703 -5.317,-6.753 -5.317,-11.284c0,-8.08 6.551,-14.63 14.631,-14.63c8.08,-0 14.63,6.55 14.63,14.63l0,0.003l0,0Zm0,-0l0,0.001c0.001,0.109 0,-0.001 0,-0.001c0,0 0.001,-0.028 0,-0Z",
    style: {
      fill: "#01abbb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.159,3.76c-0.831,-0.851 -1.97,-1.33 -3.159,-1.33c-1.189,-0 -2.328,0.479 -3.159,1.33l-0.951,0.975l-1.36,-0.017c-0.017,-0 -0.035,-0 -0.052,-0c-2.423,-0 -4.417,1.993 -4.417,4.416c-0,0.018 -0,0.035 0,0.053l0.015,1.36l-0.972,0.951c-0.85,0.83 -1.33,1.97 -1.33,3.159c0,1.188 0.48,2.328 1.33,3.159l0.974,0.95l-0.017,1.361c-0,0.017 -0,0.034 -0,0.052c-0,2.423 1.994,4.417 4.417,4.417c0.017,-0 0.035,-0 0.052,-0l1.36,-0.016l0.951,0.972c0.831,0.85 1.97,1.33 3.159,1.33c1.189,0 2.328,-0.48 3.159,-1.33l0.951,-0.973l1.36,0.017c0.017,-0 0.035,-0 0.052,-0c2.423,-0 4.417,-1.994 4.417,-4.417c0,-0.018 0,-0.035 -0,-0.052l-0.015,-1.361l0.972,-0.95c0.85,-0.831 1.33,-1.971 1.33,-3.159c-0,-1.189 -0.48,-2.329 -1.33,-3.159l-0.974,-0.951l0.017,-1.36c0,-0.018 0,-0.035 0,-0.053c0,-2.423 -1.994,-4.416 -4.417,-4.416c-0.017,-0 -0.035,-0 -0.052,-0l-1.36,0.015l-0.951,-0.972l0,-0.001Zm0.439,9.145l-4.585,4.585c-0.144,0.144 -0.338,0.225 -0.541,0.225c-0.203,-0 -0.398,-0.081 -0.541,-0.225l-2.293,-2.292c-0.143,-0.144 -0.224,-0.338 -0.224,-0.541c0,-0.42 0.345,-0.765 0.765,-0.765c0.203,-0 0.398,0.08 0.541,0.224l1.752,1.753l4.044,-4.046c0.143,-0.143 0.338,-0.224 0.541,-0.224c0.419,0 0.765,0.345 0.765,0.765c-0,0.203 -0.081,0.398 -0.224,0.541Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSMedalBadgeCheck);
export default __webpack_public_path__ + "static/media/iconS-medal-badge-check.91caff7f12600bc63405f132263f31dd.svg";
export { ForwardRef as ReactComponent };